// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiPost, BASE_URL, retrieveToken } from "../../store/api";
import { PartnerCreateResponse } from "./types";

import * as partnerActions from "./partner.actions";
import { showModal } from "../modal/modal.actions";

export function* createPartner(
  action: ReturnType<typeof partnerActions.createPartnerAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + 'partner';
    const result: Response = yield call(apiPost, url, token, action.payload);

    if (result.status === 201) {
      const parsed: PartnerCreateResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'));
      yield put(partnerActions.createPartnerAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(partnerActions.createPartnerAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(showModal('Terjadi kesalahan pada server', 'Silahkan coba kembali dalam beberapa saat'));
    yield put(partnerActions.createPartnerAsync.failure(parsed));
  }
}

export default function* partnerSagaCreatePartner() {
  yield takeEvery(partnerActions.createPartnerAsync.request, createPartner);
}
